import { render } from "./TelaLogin.vue?vue&type=template&id=cdf4c84c"
import script from "./TelaLogin.vue?vue&type=script&lang=js"
export * from "./TelaLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__